import Moment from 'react-moment';
import React from 'react';

/**
 * @description
 * Format the DATE received from the server.
 *
 * @param {string} date - DATE received from the server.
 * @param {Function} t - Translation.
 * @returns {Object} Converted and translated date.
 */
export default (date, t) => {
  const calendarStrings = {
    lastDay: `[${t('common.calendar.yesterday')} ] LT`,
    sameDay: `[${t('common.calendar.today')} ] LT`,
    lastWeek: '[] dddd[, ] LT',
    sameElse: 'L',
  };
  // 2019-02-08T15:59-0500 date for testing
  return <Moment date={date} calendar={calendarStrings} />;
};

/**
 * @description
 * Get who date value is correct in each time.
 *
 * @param {Object} date - Values - Date and field values to select the correct.
 * @returns {Object} Converted and translated date.
 */
export const getDateFromDefaultOrInitialFilter = ({
  field,
  defaultDateFilters,
  initialFilters,
}) => {
  if (initialFilters[field] === 'null') return undefined;
  if (initialFilters[field] !== undefined) return initialFilters[field];
  return defaultDateFilters[field];
};
